import { Logger, LoggerService } from "@Shared/logger";
import { NavigaLoaderOptions } from "../_models";
import { AsyncUtils, DataUtil } from "@Shared/utils";
import { APP_EVENTS } from "@Core";
import { Bus, EventModule } from "@Modules/event_module";
import { Auth0Service } from "@Modules/auth_module";
export class EngageService {

    
    private Logger: Logger = LoggerService.createLogger("EngageService");
    private static instance: EngageService;

    static get Instance() {

        if (this.instance === null || this.instance === undefined) {
            this.instance = new EngageService();
        }
        return this.instance;
    }

    constructor() {
        this.Logger.trace("****  CTOR ****");

    }

    public async init(options: NavigaLoaderOptions): Promise<void> {
        this.Logger.trace("setting up Engage Service...");
        const url = this.createLoaderOptions(options);
        Bus.emit(APP_EVENTS.onScriptLoadStart, { scriptName: "NavigaLoader" });
        
        return await DataUtil.loadScript(url).then((res) => {
            this.Logger.trace("Script loaded", res);
            this.initNavigaLoader(options);
            return Promise.resolve();
        }).catch((error) => {
            this.Logger.error("Error loading script", error);
            //TODO: What should I do here? I could create a custom event and have pagesuite listen for it and if it happens show a modal or just lock the reader.            
        }).finally(() => {
            Bus.emit(APP_EVENTS.onScriptLoadEnd, { scriptName: "NavigaLoader" });
        });
        
    }


    private createLoaderOptions(options: NavigaLoaderOptions): any{
        this.Logger.trace("createLoaderOptions...");
        const loaderUrl = `${options.baseUrl}${options.environment}/${options.version}/loader.min.js`;
        this.Logger.trace("loaderUrl", loaderUrl);
        return loaderUrl;
    }

    public async handlePaywallShown(): Promise<void> {
        const isAuthenticated = await Auth0Service.Instance.isAuthenticated();
        const logoutButtons = document.querySelectorAll<HTMLAnchorElement>('.engageLogoutLink');
        const loginButtons = document.querySelectorAll<HTMLAnchorElement>('.engageLoginLink');
        if(isAuthenticated){
            logoutButtons.forEach( ( button ) => {
				const logoutButton = button;
				logoutButton.style.visibility = 'visible';
				logoutButton.style.display = 'block';
				
			} );
			loginButtons.forEach((button) => {
				button.style.display = 'none';
			});
        }else{
            loginButtons.forEach((button) => {
				const loginButton = button;
				loginButton.style.visibility = 'visible';
				loginButton.style.display = 'block';
				
			});
			logoutButtons.forEach((button) => {
				button.style.display = 'none';
			});
        }
    }

    private initNavigaLoader(options: NavigaLoaderOptions): void {
        this.Logger.trace("initNavigaLoader...");
        window.MG2Loader.init({
			plugins: [{
				name: "FP",
				initOptions: {
					version: options.fpOptions.version,
					environment: options.fpOptions.environment,
				}
			}, {
				name: "DL",
				initOptions: {
					version: options.g2iOptions.version,
					collectors: options.g2iOptions.collectors,
					tagManager: options.g2iOptions.tagManager,
					containerId: options.g2iOptions.containerId,
				}
			}, {
				name: "NXT",
				initOptions: {
					clientCode: options.engageOptions.clientCode,
					environment: options.engageOptions.environment,
					siteCode: options.engageOptions.siteCode,
					configCode: options.engageOptions.configCode,
					debug: options.engageOptions.debug,
					silentmode: options.engageOptions.silentMode,
					checkUserDataEveryPageload: false,
					settingsKey: options.engageOptions.settingsKey,
                    attr: options.engageOptions.attr,
					authSettings: options.engageOptions.authSettings,
                    articleIdProvider: function(){
                        return window.location.href;
                    },
                    publicEventHandlers:{
                        onInit: () => {
                            this.Logger.info("Engage onInit");
                            
                        },
                        onPaywallShown: () => {
                            this.Logger.info("Engage onPaywallShown");
                            this.handlePaywallShown();
                            
                        },
                        onRun: () => {
                            this.Logger.info("Engage onRun");
                            Bus.emit(APP_EVENTS.onScriptLoadStart, { scriptName: "EngageFinish" });
                        },
                        onFinish: () => {
                            this.Logger.info("Engage onFinish");
                            Bus.emit(APP_EVENTS.onScriptLoadEnd, { scriptName: "EngageFinish" });                            
                            const duration = EventModule.PerfTracker.getDurations("scriptLoad:EngageFinish");
                            this.Logger.trace("Engage On Finish Single", duration);
                        }
                    }
					
				}
			}]
		});
    }

}